
import { Link } from 'react-router-dom';
import { StringConvert } from '../components/StringConvert';



const truncateText = (text, maxLength) => {
    if(text) {
      if (text.length <= maxLength) {
        return text;
      }
      return text.slice(0, maxLength) + '...';
    }
    return text;
  };


const CarWithDriverCard = ({data}) => {
    const {id,banner_image,title,description,type,slug} = data
      const maxLength = 200;
      const truncatedText = truncateText(description, maxLength);

    return (
        <div className='BlogsCard group relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(18,38,63,0.10)]'>
            <Link className="BlogsCardMain flex flex-col gap-4 p-4 lg:flex-row lg:items-center" to={`/carwithdrivers/edit/${id}`}>
                <div className="BlogsCard__left w-full lg:w-[12rem] lg:flex-none">
                    {banner_image ? <img src={banner_image} className='h-[11rem] w-full rounded-[1.25rem] object-cover lg:h-[8rem]' alt={title || "car with driver"} /> : <div className='flex h-[11rem] w-full items-center justify-center rounded-[1.25rem] border border-dashed border-[#D4DEF1] bg-[#EFF4FD] text-sm text-[#7D8CA7] lg:h-[8rem]'>No Image</div>}
                </div>
                <div className="BlogsCard__leftRight min-w-0 flex-1 lg:pr-4">
                    <div className="mb-2 max-h-[3.1rem] overflow-hidden text-[1.1rem] capitalize font-MluvkaLight leading-[1.2] text-[#101828] lg:text-[1.25rem]">{title}</div>
                    <div className='mb-3 max-h-[4.9rem] overflow-hidden text-[.88rem] leading-[1.65] text-[#475467]'>{StringConvert(truncatedText)}</div>
                    <div className='text-[.75rem] leading-[1.5] text-[#7D8CA7]'>Type: {type || "-"}</div>
                    <div className='break-all text-[.75rem] leading-[1.5] text-[#7D8CA7]'>Slug: {slug || "-"}</div>
                </div>
                <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
                    <span className="text-sm font-MluvkaBold text-[#0F172A]">Open</span>
                    <span className="rounded-full bg-[#EFF4FD] px-4 py-2 text-sm font-MluvkaBold text-primary transition-colors group-hover:bg-primary group-hover:text-white">
                        Edit
                    </span>
                </div>
            </Link>
        </div>
    )
}

export default CarWithDriverCard
